import config from './config';

const generateID2 = (callback: (value: string | null) => void) => {
  (() => {
    const script = document.createElement('script');
    script.async = true;
    script.src = `${config.URL_ID3}/js/loader.js`;
    script.onload = onLoadLoaderScript;
    document.getElementsByTagName('head')[0].appendChild(script);
  })();

  function onLoadLoaderScript() {
    //@ts-ignore
    window.AuthButton.init({ appId: config.APP_ID, typeBtn: 1, handleToken, handleLogout });
  }

  function handleToken(token: string, userId: number) {
    localStorage.setItem('token', token);
    callback(token);
  }

  function handleLogout() {
    localStorage.removeItem('token');
    callback(null);
  }

  setInterval(async () => {
    //@ts-ignore
    if (window.AuthButton) {
      //@ts-ignore
      const token = await window.AuthButton?.refreshToken();
      localStorage.setItem('token', token);
    }
  }, 1000 * 60 * 25);
};

export default generateID2;
